import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { CreditNotesRepository } from "../Repositories/credit-notes.repository";
import { CreditNotesFilter, CreditNotesReportFilter } from "../Types/Interfaces/credit-notes-filter.interface";
import { CreditNotes } from "../Types/Interfaces/credit-notes.interface";
import { CreditNoteEmail } from "../Types/Interfaces/CreditNoteEmail.interface";
import { DropdownSeguros } from "../Types/Interfaces/dropdown-seguros.interface";

@Injectable({
  providedIn: "root",
})
export class CreditNotesService {
  constructor(private creditNotesRepository: CreditNotesRepository, private fileHandlerService: FileHandlerService) {}

  public getEstatus(): Observable<DropdownSeguros[]> {
    return this.creditNotesRepository.getEstatus();
  }
  public getDocumentTypes(): Observable<DropdownSeguros[]> {
    return this.creditNotesRepository.getDocumentTypes();
  }
  public getCreditNotes(polizaFilter: CreditNotesFilter): Observable<CreditNotes[]> {
    return this.creditNotesRepository.getCreditNotes(polizaFilter);
  }

  public getHealthPolicies(): Observable<DropdownSeguros[]> {
    return this.creditNotesRepository.getHealthPolicies();
  }

  public getCreditNotesReport(creditNotesReportFilter: CreditNotesReportFilter): void {
    this.creditNotesRepository
      .getCreditNotesReport(creditNotesReportFilter)
      .pipe(first())
      .subscribe((report) => {
        this.fileHandlerService.openPdfInNewTab(report);
      });
  }

  public sendEmailCreditNote(request: CreditNoteEmail): Observable<ShareMessageResponse> {
    return this.creditNotesRepository.sendEmailCreditNote(request);
  }
}
